import React from 'react';
import PropTypes from 'prop-types';
import DropdownBase from '../DropdownBase/DropdownBase';

export default function DropdownControlled(props) {
    return (
        <DropdownBase
            {...props}
        />
    );
}

DropdownControlled.propTypes = {
    /** id attribute of the Dropdown. Used for aria-labeledby value of dropdown list. */
    id: PropTypes.string.isRequired,
    /** Text to display on the Dropdown button. */
    label: PropTypes.node.isRequired,
    /** Array of links to generate.  Shape contains: `link`, `text`, and `cssClass`. */
    links: PropTypes.arrayOf(PropTypes.shape({
        link: PropTypes.string,
        text: PropTypes.string,
        className: PropTypes.string
    })),
    /** Flag to control if the Dropdown is open via an external state management. */
    open: PropTypes.bool,
    /** Child content of Dropdown button if not using standard label prop. */
    buttonChildren: PropTypes.node,
    /** Render the toggle as a custom React component. */
    customToggle: PropTypes.element,
    /** Flag to specify that the button label is Screen Reader only. Usually used with props.buttonChildren. */
    srOnlyLabel: PropTypes.bool,
    /** Flag to keep the arrow icon from appearing to the right of the text. */
    noArrow: PropTypes.bool,
    /** Flag to keep have the dropdown menu open from the right. */
    dropdownRight: PropTypes.bool,
    /** callback for when the dropdown toggle is clicked */
    onDropdownClick: PropTypes.func,
    /** callback for when the dropdown contents are clicked - can be used to close the dropdown after selecting an item, for example */
    onDropdownContentClick: PropTypes.func,
    /** callback for touch devices tapping off of the dropdown / dropdown list */
    onTouch: PropTypes.func,
    /** callback for when the dropdown / dropdown list loses focus */
    onBlur: PropTypes.func,
    /** Set max height of the dropdown menu */
    maxHeight: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    /** A11y role, use role 'menu' to enable arrow keys navigation. */
    role: PropTypes.string
};
